import React, { Component } from "react";
import Slider from "react-slick";
import GithubCommitActivity from "../commit-activity/index";
import GithubCode from "../github-code/index";
import GithubOverview from "../github-overview/index";
import "../index.css";

const LeftArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`left-arrow`}
      onClick={onClick}
      style={{
        ...style
      }}
    >
      <i
        style={{ fontSize: 20, color: "#A7A7A7" }}
        className="fa fa-long-arrow-left"
      />
    </button>
  );
};

const RightArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`right-arrow`}
      onClick={onClick}
      style={{
        ...style
      }}
    >
      <i
        style={{ fontSize: 20, color: "#A7A7A7" }}
        className="fa fa-long-arrow-right"
      />
    </button>
  );
};

class GithubStatsMobile extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <RightArrow />,
      prevArrow: <LeftArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <section id="github-stats-section">
        <div className="row">
          <div className="col-12">
            <Slider {...settings}>
              {/* <GithubOverview /> */}
              <div className="github-stat-tab-col-1">
                <GithubCommitActivity />
              </div>
              <div className="github-stat-tab-col-2">
                <GithubCode />
              </div>
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default GithubStatsMobile;
